import React from 'react';
import {ISelectProps, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {Intent} from '~/lib/intent';
import {useBiddersQuery} from '~/modules/Bidders/queries';

type ISelectBidderProps = Omit<ISelectProps<string>, 'items'>;

export const SelectBidder = ({
    disabled,
    ...props
}: ISelectBidderProps) => {
    const {data: bidders = [], isLoading} = useBiddersQuery();
    return <SelectInput {...props} disabled={disabled || isLoading}
        rightIcon={isLoading && <i className='fa fa-spinner fa-spin'/>}
        items={bidders.map(bidder => ({
            label: bidder.title,
            value: bidder.id
        }))}/>;
};

export const SelectBidderField = (props: IFieldProps<ISelectBidderProps>) => <FormField {...props}>
    <SelectBidder {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
